

class FieldService {
  getFieldComponent(field) {
    const componentMap = {
      'reference': 'ReferenceField',
      'picklist': 'PicklistField',
      'date': 'DateField',
      'datetime': 'DateField',
      'number': 'NumberField',
      'currency': 'NumberField',
      'text': 'TextField',
      'textarea': 'TextAreaField',
      'email': 'EmailField',
      'phone': 'PhoneField',
      'url': 'URLField',
      'boolean': 'BooleanField'
    };

    return componentMap[field.type] || 'TextField';
  }

  isDateTimeField(field) {
    if (!field) return false;
    
    // Check metadata first
    if (field.metadata?.field_type === 'datetime') return true;
    
    // Check type
    return ['date', 'datetime'].includes(field.type);
  }

  isReferenceField(field) {
    return field?.type === 'reference' || field?.metadata?.reference_to;
  }

  getReferenceEndpoint(field, metadata) {
    // Get from field metadata first
    if (field.metadata?.reference_endpoint) {
      return field.metadata.reference_endpoint;
    }

    // Get from object metadata
    const referenceTo = field.metadata?.reference_to;
    if (referenceTo && metadata.objectMetadata[referenceTo]) {
      return metadata.objectMetadata[referenceTo].metadata?.reference_endpoint;
    }

    // Fallback to constructing endpoint
    return `/${referenceTo || field.id.replace('_id', '')}s/`;
  }

  getLabelField(field, metadata) {
    // Get from field metadata first
    if (field.metadata?.label_field) {
      return field.metadata.label_field;
    }

    // Get from referenced object metadata
    const referenceTo = field.metadata?.reference_to;
    if (referenceTo && metadata.objectMetadata[referenceTo]) {
      return metadata.objectMetadata[referenceTo].metadata?.label_field || 'name';
    }

    return 'name';
  }

  formatFieldValue(value, field) {
    if (value == null) return '';

    switch (field.type) {
      case 'date':
        return this.formatDate(value);
      case 'datetime':
        return this.formatDateTime(value);
      case 'currency':
        return this.formatCurrency(value, field.metadata?.currency);
      case 'boolean':
        return value ? 'Yes' : 'No';
      default:
        return String(value);
    }
  }

  formatDate(value) {
    if (!value) return '';
    const date = new Date(value);
    return date.toLocaleDateString();
  }

  formatDateTime(value) {
    if (!value) return '';
    const date = new Date(value);
    return date.toLocaleString();
  }

  formatCurrency(value, currency = 'USD') {
    if (!value) return '';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency
    }).format(value);
  }

  getDefaultValue(field) {
    if (field.metadata?.default_value) {
      return field.metadata.default_value;
    }

    switch (field.type) {
      case 'boolean':
        return false;
      case 'number':
      case 'currency':
        return 0;
      case 'picklist':
        return field.options?.[0] || '';
      default:
        return '';
    }
  }
}

export default new FieldService();
